// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IFirmwareUpdateCommandParams {
	firmwareId: string | undefined;

	v: string | undefined;

	url: string | undefined;

	hash: string | undefined;

	force: boolean;

	$type?: string | undefined;
}
export class FirmwareUpdateCommandParams {
	constructor(data?: IFirmwareUpdateCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	firmwareId: string | undefined;

	v: string | undefined;

	url: string | undefined;

	hash: string | undefined;

	force: boolean = false;

	static $type: string = "CoreApi.Models.DeviceCommands.FirmwareUpdateCommandParams, ";
	$type?: string | undefined = FirmwareUpdateCommandParams.$type;
}

